// utils.js
const roleDisplayNames = {
  admin: 'Admin',
  publish: 'Publisher',
  edit: 'Editor',
  view: 'Viewer',
  none: 'None',
};

const getUserName = (user) => {
  if (user.first_name || user.last_name) {
    return `${user.first_name || ''} ${user.last_name || ''}`.trim();
  } else {
    return getUserNameFromEmail(user.email);
  }
};
const getUserNameFromEmail = (email) => {
  const parts = email.split('@');
  if (parts.length === 2) {
    return parts[0];
  } else {
    // Handle the case where the email does not have an '@' symbol or it has more than one
    console.error('Invalid email address');
    return null;
  }
};
const searchFunction = (data, searchValue) => {
  return new Promise((resolve) => {
    if (data) {
      const availableEntities = data.filter((entity) => {
        if (entity.first_name || entity.last_name || entity.email) {
          // User entity
          return (
            (entity.first_name &&
              entity.first_name.toLowerCase().includes(searchValue.toLowerCase())) ||
            (entity.last_name &&
              entity.last_name.toLowerCase().includes(searchValue.toLowerCase())) ||
            (entity.email &&
              entity.email.toLowerCase().includes(searchValue.toLowerCase()))
          );
        } else if (entity.name) {
          // Team entity
          return entity.name.toLowerCase().includes(searchValue.toLowerCase());
        }
        return false;
      });
      resolve(availableEntities);
    } else {
      // If availableEntities is not defined or unavailable, resolve the Promise with an empty array
      resolve([]);
    }
  });
};

// Helper function to format the date
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

export {
  roleDisplayNames,
  getUserName,
  getUserNameFromEmail,
  searchFunction,
  formatDate,
};
